import { render, staticRenderFns } from "./Number_Rank.vue?vue&type=template&id=9b8e435e&scoped=true&"
import script from "./Number_Rank.vue?vue&type=script&lang=js&"
export * from "./Number_Rank.vue?vue&type=script&lang=js&"
import style0 from "./Number_Rank.vue?vue&type=style&index=0&id=9b8e435e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8e435e",
  null
  
)

export default component.exports